import {ArrowDropDown, ArrowDropUp} from "@mui/icons-material"
import {Box, Collapse, Tooltip} from "@mui/material"
import {useState} from "react"

import {Refresher} from "../../../core/widgets/browser/Refresher"
import {HeadBox} from "../../../shared/component/box/HeadBox"
import {SimpleButton} from "../../../shared/component/button/SimpleButton"
import {SxPropsMap} from "../../../shared/helper/HelperType"
import {useRouterActivity} from "../api/QueryHook"
import {QueryApi} from "../api/QueryRouter"
import {Connection} from "../api/QueryType"
import {QueryTable} from "./QueryTable"

const SX: SxPropsMap = {
    box: {display: "flex", flexDirection: "column"},
    help: {fontSize: "9px", fontWeight: "normal", color: "text.disabled", textAlign: "center"},
    action: {display: "flex", justifyContent: "end", gap: 1, color: "text.secondary", cursor: "pointer"},
    info: {
        display: "flex", justifyContent: "center", alignItems: "center", padding: "0 15px",
        fontSize: "11px", color: "text.secondary", textAlign: "center",
    },
    icon: {fontSize: "16px", color: "text.secondary"},
    error: {color: "error.light"},
    collapse: {
        marginTop: "10px", display: "flex", flexDirection: "column", gap: 1, backgroundColor: "background.paper",
        backgroundImage: "var(--Paper-overlay)",
    },
    count: {
        display: "flex", fontSize: "14px", color: "info.main", border: 1, borderRadius: 1, bgcolor: "rgb(2 131 237 / 0.10)",
        borderColor: "divider", width: "32px", height: "32px", alignItems: "center", justifyContent: "center",
    },
}

type Props = {
    connection: Connection,
}

export function QueryActivity(props: Props) {
    const {connection} = props
    const [open, setOpen] = useState(false)
    const {data, isError, error, refetch} = useRouterActivity(connection)
    const table = isError ? undefined : data
    return (
        <Box sx={SX.box}>
            <HeadBox title={"Session Active Queries"}>
                {open && <Box sx={[SX.help, {flex: 1}]}>[ hold shift for horizontal scrolling ]</Box>}
                <Box sx={[SX.action, {flex: 1}]}>
                    <Tooltip title={"COUNT"} placement={"top"}>
                        <Box sx={SX.count}>{error || !data ? "-" : data.rows.length - 1}</Box>
                    </Tooltip>
                    <Refresher queryKeys={[QueryApi.activity.key()]} defaultPeriod={["5s", 5000]}/>
                    <SimpleButton tooltip={!open ? "Show Queries" : "Hide Queries"} onClick={() => setOpen(!open)}>
                        {open ? <ArrowDropUp sx={SX.icon}/> : <ArrowDropDown sx={SX.icon}/>}
                    </SimpleButton>
                </Box>
            </HeadBox>
            <Collapse in={open}>
                <Box sx={SX.collapse}>
                    <QueryTable
                        connection={connection}
                        refetch={refetch}
                        height={100}
                        data={table}
                        error={error}
                        showIndexColumn={false}
                    />
                    <Box sx={SX.info}>
                        This section displays queries submitted within your current session in Ivory
                    </Box>
                </Box>
            </Collapse>
        </Box>
    )
}
